import * as yup from "yup";
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from "@Shared/utils/validationSchema";

export interface IAssetsDataTableRowFormMeta {
  assetsDescription: FormInputMeta;
  account: FormInputMeta;
  accountHolderName: FormInputMeta;
  flowSubject: FormInputMeta;
  value: FormInputMeta;

  schema: any;
}

const assetsDataTableRowFormMeta = {} as IAssetsDataTableRowFormMeta;

assetsDataTableRowFormMeta.assetsDescription = {
    name: "assetsDescription",
    type: "select",
    label: "Description des Biens",
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !"),
};

assetsDataTableRowFormMeta.account = {
    name: "account",
    type: "text",
    label: "Compte",
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !"),
};

assetsDataTableRowFormMeta.accountHolderName = {
    name: "accountHolderName",
    type: "text",
    label: "Nom du Détenteur du Compte",
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !"),
};

assetsDataTableRowFormMeta.value = {
    name: "value",
    type: "number",
    label: "Valeur",
    placeholder: "",
    validation: yup.number(),
};

assetsDataTableRowFormMeta.flowSubject = {
    name: "flowSubject",
    type: "checkbox",
    label: "Sujet au Débit",
    placeholder: "",
    validation: yup.boolean(),
};

assetsDataTableRowFormMeta.schema = yup.object().shape(getValidationSchema(assetsDataTableRowFormMeta));

export default assetsDataTableRowFormMeta;